<template>
	<footer class="footer">
		<div class="footer__container">

			<div class="footer__brand">
				<img :src="AppConfigs.staticImages.LOGO" alt="Bounty Hunter" class="footer__logo" />

				<div class="footer__social">
					<span class="footer__social-icon d-flex align-center justify-center" @click="navigateTo('https://www.instagram.com/bountyhunterapp/')">
						<v-icon>
							<instagram-white />
						</v-icon>
					</span>
					<span class="footer__social-icon d-flex align-center justify-center" @click="navigateTo('https://www.facebook.com/bountyhunterapp/')">
						<v-icon>
							<facebook-white />
						</v-icon>
					</span>
					<span class="footer__social-icon d-flex align-center justify-center" @click="navigateTo('https://twitter.com/bountyhunterapp')">
						<v-icon>
							<twitter-white />
						</v-icon>
					</span>
				</div>
			</div>



			<div class="footer__company">
				<h2 class="footer__section-title">Company</h2>
				<nav class="footer__links">
					<div class="footer__link" @click="redirectToTos">Terms of Service</div>
					<div class="footer__link" @click="redirectToPolicy">Privacy Policy</div>
					<div class="footer__link" @click="redirectToCookie">Cookie Policy</div>
				</nav>
			</div>

			<div class="footer__support">
				<h2 class="footer__section-title">Support</h2>
				<nav class="footer__links">
					<div class="footer__link" @click="redirectToFaq">FAQ</div>
					<div class="footer__link" @click="ContactClicked">Contact</div>
					<div class="footer__link">
						<a href="#" id="open_preferences_center">Manage cookies</a>
					</div>
				</nav>
			</div>


		</div>




		<ContactUsDialog />
		<HowItWorksDialog />
	</footer>

</template>



<script setup>

import { ref, provide } from "vue";
import { useRouter } from 'vue-router';
import { AppConfigs } from "@/app.configs";
import { scrollToTop } from "@/utils/utils.ts";
import HowItWorksDialog from "@/components/Common/How-It-Works-Dialog.vue";
import ContactUsDialog from "@/components/Faq/ContactUs/Contact-Us-Dialog.vue";
import InstagramWhite from "@/icons/InstagramWhite.vue";
import FacebookWhite from "@/icons/FacebookWhite.vue";
import TwitterWhite from "@/icons/TwitterWhite.vue";


const router = useRouter();

// Dialog refs and handlers
const openDialog = ref(false);
provide("openDialog", openDialog);

const ContactClicked = () => {
  openDialog.value = true;
};


const howItWorksDialog = ref(false);
provide("howItWorksDialog", howItWorksDialog);


// Navigation methods
const navigateTo = (url) => {
  window.open(url, "_blank");
};

const redirectToFaq = () => {
  router.push({ path: "/faqs" });
  scrollToBottom();
};

const redirectToTos = () => {
  router.push({ path: "/tos", query: { from: 'footer' } });
  scrollToTop();
};

const redirectToPolicy = () => {
  router.push({ path: "/policy", query: { from: 'footer' } });
  scrollToTop();
};

const redirectToCookie = () => {
  router.push({ path: "/cookie" });
  scrollToTop();
};

const scrollToBottom = () => {
  window.scrollTo(0, document.body.scrollHeight);
};

</script>